import api from './base'

export default {
  getAll ({ childCompanyId }) {
    return api().get(`company/child_companies/${childCompanyId}/certificates`)
  },
  getById ({ childCompanyId, certificateId }) {
    return api().get(`company/child_companies/${childCompanyId}/certificates/${certificateId}`)
  },
  save ({ childCompanyId, item }) {
    return api().put(`company/child_companies/${childCompanyId}/certificates`, item)
  },
  delete ({ childCompanyId, certificateId }) {
    return api().delete(`company/child_companies/${childCompanyId}/certificates/${certificateId}`)
  },
  setActive ({ childCompanyId, certificateId, active }) {
    return api().put(`company/child_companies/${childCompanyId}/certificates/${certificateId}/status`, { active })
  },
  getCertificateWarnings () {
    return api().get(`company/certificate_warnings`)
  }
}
